const STORAGE_KEY = "user_acquisition";

/** localStorage persiste entre sessões até o cadastro; sessionStorage como cópia na mesma aba. */
const STORAGE_BACKENDS = ["localStorage", "sessionStorage"];

const TRACKING_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_adset",
  "utm_content",
  "fbclid",
];

const MAX_LENGTHS = {
  utm_source: 120,
  utm_medium: 120,
  utm_campaign: 180,
  utm_adset: 180,
  utm_content: 180,
  fbclid: 255,
  landing_path: 255,
};

function truncate(value, maxLength) {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  return trimmed.slice(0, maxLength);
}

function readFromStorage(storage) {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

function writeToStorages(data) {
  const serialized = JSON.stringify(data);
  for (const backend of STORAGE_BACKENDS) {
    try {
      window[backend].setItem(STORAGE_KEY, serialized);
    } catch {
      // quota privada ou storage indisponível — não bloqueia o fluxo
    }
  }
}

function clearStorages() {
  for (const backend of STORAGE_BACKENDS) {
    try {
      window[backend].removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }
}

export function getStoredAcquisition() {
  if (typeof window === "undefined") {
    return null;
  }

  return (
    readFromStorage(window.localStorage) ||
    readFromStorage(window.sessionStorage)
  );
}

function hasTrackingData(data) {
  if (!data || typeof data !== "object") {
    return false;
  }

  return TRACKING_PARAMS.some((key) => Boolean(data[key]));
}

export function parseTrackingFromHref(href) {
  const url = new URL(href, "https://example.com");
  const data = {};

  for (const key of TRACKING_PARAMS) {
    const value = truncate(url.searchParams.get(key), MAX_LENGTHS[key]);
    if (value) {
      data[key] = value;
    }
  }

  if (Object.keys(data).length === 0) {
    return null;
  }

  data.landing_path = truncate(
    `${url.pathname}${url.search}`,
    MAX_LENGTHS.landing_path
  );

  return data;
}

function readTrackingFromUrl() {
  const data = parseTrackingFromHref(window.location.href);
  if (!data) {
    return null;
  }

  return {
    ...data,
    first_seen_at: new Date().toISOString(),
  };
}

export function captureAcquisitionFromUrl() {
  if (typeof window === "undefined") {
    return null;
  }

  const existing = getStoredAcquisition();
  const fromUrl = readTrackingFromUrl();
  if (!fromUrl) {
    return existing;
  }

  const merged = {
    ...(existing || {}),
    ...fromUrl,
    first_seen_at: fromUrl.first_seen_at,
  };

  writeToStorages(merged);
  return merged;
}

export function getAcquisitionForRegister() {
  const stored = getStoredAcquisition();
  if (!stored || !hasTrackingData(stored)) {
    return null;
  }

  const payload = {};
  for (const key of [...TRACKING_PARAMS, "landing_path", "first_seen_at"]) {
    if (stored[key]) {
      payload[key] = stored[key];
    }
  }

  return Object.keys(payload).length > 0 ? payload : null;
}

export function clearStoredAcquisition() {
  if (typeof window === "undefined") {
    return;
  }
  clearStorages();
}
